import React, { useEffect, useState, useRef } from 'react'
import {
    // Router,
    useHistory,
    useLocation,
} from 'react-router-dom'
import {
    rebuildHistory,
} from 'actions/appActions'
import {
    CustomEventType,
} from 'app/types'
import { useAppSelector, useAppDispatch } from 'app/hooks'

export function HistoryManager(props) {
    const history = useHistory()
    const location = useRef(null)
    const currentLocation = useLocation() // Get current location object
    const dispatch = useAppDispatch()
    const initialized = useAppSelector((state:RootState) => state.app.initialized)
    const project = useAppSelector((state:RootState) => state.app.projectCurrent[0])
    const [historyInitialized, setHistoryInitialized] = useState(false)

    // History
    useEffect(() => {
        function handlePush(e) {
            const currentPath = window.location.pathname
            const incomingPath = e.detail
            
            // Check if there's a basename configured
            let basename = ''
            try {
                // Try to access internal router properties (may not work in all versions)
                // @ts-ignore - Accessing private properties for debugging
                const router = history?.router
                // @ts-ignore - Accessing private properties for debugging
                basename = router?.basename || ''
            } catch (err) {
                
            }
            
            // Determine expected path based on whether the incoming path has a leading slash
            const expectedPath = typeof incomingPath === 'string' 
                ? (incomingPath.startsWith('/') 
                    ? incomingPath // Absolute path - replaces current path
                    : `${currentPath}/${incomingPath}`) // Relative path - appends to current path
                : incomingPath // Handle object case
                
            
            // Push to history
            history.push(e.detail)
            
        }
        
        function handleReplace(e) {
            history.replace(e.detail)
        }
        function handleBack(e) {
            history.goBack()
        }
        window.addEventListener(CustomEventType.HistoryPush, handlePush)
        window.addEventListener(CustomEventType.HistoryReplace, handleReplace)
        window.addEventListener(CustomEventType.HistoryBack, handleBack)
    }, [])

    useEffect(() => {
        if (initialized >= 2 && !historyInitialized) {
            history.listen((newLocation) => {
                if (!location.current || newLocation.pathname != location.current) {
                    location.current = newLocation.pathname
                    dispatch(rebuildHistory())
                }
            })
            dispatch(rebuildHistory())
            setHistoryInitialized(true)
        }
    }, [history, currentLocation, project])

    // useEffect(() => {
        // if(initialized >= 2)
        // dispatch(rebuildHistory())
    // }, [project])

    return props.children
}